import React from 'react';
import { Card } from 'react-bootstrap';
import ContentLoader from 'react-content-loader';

const ProjectCardLoader = () => {
    return (
        <Card className="project-content box-shadow d-flex justify-content-center align-items-center">
            <ContentLoader
                speed={3}
                width="250px"
                height="320px"
                viewBox="0 0 100% 320"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
            >
                <rect x="0" y="8" rx="8" ry="8" width="250px" height="320px" />
            </ContentLoader>

            <Card.Title className="p-2 mb-0">
                <ContentLoader
                    speed={3}
                    width="250px"
                    height="32px"
                    viewBox="0 0 100% 32px"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                >
                    <rect x="0" y="16" rx="8" ry="8" width="250" height="32" />
                </ContentLoader>
            </Card.Title>
        </Card>
    );
};

export default ProjectCardLoader;
